//import Debug from "./Debug";
import React, {useEffect, useState, useCallback} from 'react';
import { ibanCheckAPI } from "../../../api/iban-check/ibanCheckAPI"
import Form from "./Form";
import {PopUp} from "../../components/PopUp/PopUp"
import LoadingOverlay from 'react-loading-overlay-ts';



function FormIBAN({ initialValues, validate }) {
  const [values, setValues] = React.useState(initialValues);

  const [errors, setErrors] = React.useState({});

  const [touched, setTouched] = React.useState({});

  const  [showPopup, setPopup]=  React.useState(false);

  const [isActive, setActive] = useState(false)


  function togglePopup() {
    setPopup({
      showPopup: !showPopup
    });
  };

  // change event handler
  const handleChange = evt => {
    const { name, value: newValue, type } = evt.target;

    // keep number fields as numbers
    const value = type === "number" ? +newValue : newValue;

    // save field values
    setValues({
      ...values,
      [name]: value
    });

    // was the field modified
    setTouched({
      ...touched,
      [name]: true
    });
  };

  const handleBlur = evt => {
    const { name, value } = evt.target;

    // remove whatever error was there previously
    const { [name]: removedError, ...rest } = errors;

    // check for a new error
    const error = validate[name](value);

    // // validate the field if the value has been touched
    setErrors({
      ...rest,
      ...(error && { [name]: touched[name] && error })
    });
  };

  // form submit handler
  const handleSubmit = evt => {
    evt.preventDefault();

    // validate the form
    const formValidation = Object.keys(values).reduce(
      (acc, key) => {
        const newError = validate[key](values[key]);
        const newTouched = { [key]: true };
        return {
          errors: {
            ...acc.errors,
            ...(newError && { [key]: newError })
          },
          touched: {
            ...acc.touched,
            ...newTouched
          }
        };
      },
      {
        errors: { ...errors },
        touched: { ...touched }
      }
    );
    setErrors(formValidation.errors);
    setTouched(formValidation.touched);

    if (
      !Object.values(formValidation.errors).length && // errors object is empty
      Object.values(formValidation.touched).length ===
        Object.values(values).length && // all fields were touched
      Object.values(formValidation.touched).every(t => t === true) // every touched field is true
    ) {
      //alert(JSON.stringify(values, null, 2));
      if(values.piva === '' && values.cf === '')
      {
        setPopup({showPopup: !showPopup});
      }
      else
      {

      var arr = [{'ID' :  values.id, 'IBAN': values.iban, 'PIVA':values.piva, 'CF':values.cf}];
              var payload = {data: arr }  ;// nominationList;

              var code = window.sessionStorage.getItem('code');

              setActive(value => !value);

              ibanCheckAPI.getIbanCheck(arr, code, (res) => {
                if (!res || res.length === 0) {
                  this.setState(values);
                  setActive(value => !value);
                }
                else {
                  //setValues(res[0]);
                  var val = values;
                  val.esito = res[0].esito;
                  val.isValid = res[0].isvalidbintesa;
                  setValues(val);
                  //this.setState({ values: values });

                  setActive(value => !value);
                  //togglePopup.bind(this);
                  //setPopup({showPopup: !showPopup});
                }
              })

    }

    }
  };

  const handleClean = () => {
    
    setValues(initialValues);
  };

   const hideModal = () => {
    setPopup(false);
  }

  const showPop = showPopup;

  return (
    <>
      <h2 className="row justify-content-md-center">Inserire IBAN e Codice Fiscale / P.IVA da verificare:</h2>
      <LoadingOverlay
      active={isActive}
      spinner
      text='Loading ...'
    >
      <Form
        handleBlur={handleBlur}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={errors}
        touched={touched}
        values={values}
        handleClean = {handleClean}
      />
      {/* <Debug values={values} errors={errors} touched={touched} /> */}

      </LoadingOverlay>
      {/* {showPopup ? (<PopUp  text='Close Me'  closePopup={togglePopup.bind(this)}  />) : (null)} */}
      <PopUp show={showPopup} handleClose={hideModal}>

        <div className="row" style={{height: "30px", marginLeft:"0px", marginRight:"0px", backgroundColor: "#FDA443", borderRadius:"10px 10px 0px 0px"}}> </div>
          <p></p>
          <h3 className="row justify-content-md-center" style={{marginLeft:"10px", marginRight:"10px"}}> Attenzione: Valorizzare almeno Codice Fiscale o P.IVA!</h3>
          <p></p>
      </PopUp>
    </>
  );
}

 export default FormIBAN;
